<template>
  <el-dialog
    width="500px"
    modal-append-to-body
    append-to-body
    custom-class="dialog_box"
    :title="edit ? '编辑品牌&&关键词' : '新建品牌&&关键词'"
    :visible.sync="visible"
    :before-close="beforeClose"
  >
    <el-form
      ref="brandForm"
      :model="formData"
      :rules="formRules"
      size="small"
      label-position="right"
      label-width="80px"
      label-suffix=":"
    >
      <el-form-item label="企业" prop="enterpriseName" required>
        <el-select
          clearable
          v-model="formData.enterpriseName"
          style="width: 100%"
        >
          <el-option
            v-for="e in enterpriseList"
            :key="e.enterpriseId"
            :label="e.enterpriseName"
            :value="e.enterpriseName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品牌名称" prop="brandName" required>
        <el-input v-model="formData.brandName" maxlength="12"></el-input>
      </el-form-item>
      <el-form-item label="本品/竞品" prop="isCompete" required>
        <el-radio-group v-model="formData.isCompete">
          <el-radio :label="0">本品</el-radio>
          <el-radio :label="1">竞品</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="品牌logo" prop="brandLogo">
        <el-upload
          ref="brandUpload"
          class="upload-demo"
          accept=".png,.svg,.jpg"
          action=""
          :auto-upload="false"
          :on-change="importModel"
          :on-remove="removeFile"
        >
          <el-button icon="el-icon-document-add" size="small" plain>
            {{ edit ? "重新上传" : "上传logo" }}
          </el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
        </el-upload>
      </el-form-item>

      <el-form-item label="关键词" prop="keyword" required>
        <el-input
          style="margin-top: 10px"
          :maxlength="12"
          show-word-limit
          clearable
          v-model="keywordList[index]"
          v-for="(keyword, index) in keywordList"
          :key="index"
          @change="changeKeyword"
        >
          <el-button
            slot="append"
            @click.prevent="removeKeyword(keyword, index)"
            >删除</el-button
          >
        </el-input>
      </el-form-item>
      <div style="padding-left: 80px">
        <el-button
          size="small"
          icon="el-icon-plus"
          style="width: 100%"
          plain
          @click="addKeyword"
        >
          添加关键词
        </el-button>
      </div>
      <el-form-item label="取数状态" prop="status" v-if="edit">
        <el-switch
          v-model="formData.status"
          :active-value="0"
          :inactive-value="1"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <div class="form_footer">
      <el-button size="small" @click="beforeClose">取消</el-button>
      <el-button size="small" type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import formRules from "./rules";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    enterpriseList: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      defalut: false,
    },
    initFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        enterpriseName: "",
        enterpriseId: "",
        brandName: "",
        brandLogo: "",
        isCompete: 0,
        keyword: "",
        status: 0,
      },
      keywordList: [],
      formRules: formRules,
      fileList: [],
    };
  },
  watch: {
    visible(val) {
      if (val && this.edit) {
        this.initData();
      }
    },
  },
  methods: {
    // 监听改变关键词事件
    changeKeyword() {
      this.formData.keyword = this.keywordList.filter((key) => key).join("|");
    },
    initData() {
      if (this.edit) {
        this.formData = { ...this.initFormData };
        this.fileList = [
          { url: this.initFormData.brandLogo, name: "品牌logo.png" },
        ];
        this.keywordList = this.initFormData.keyword.split(",");
      }
    },
    //格式限制
    onFormat(file) {
      let canUpload = true;
      const { size, name = "" } = file;
      const isGt1M = size / 1024 / 1024 > 1; //是否大于1M
      if (isGt1M) {
        canUpload = false;
        this.$message.warning("上传文件大小超过1M，请重新上传");
      }
      // , "jpeg"  "webp"
      if (!["png", "jpg"].includes(name.split(".")[1])) {
        canUpload = false;
        this.$message.warning("请上传正确的图片文件类型哦");
      }
      if (!canUpload) {
        this.$refs.brandUpload.clearFiles();
        this.fileList = [];
      }
      return canUpload;
    },
    // 导入模板文件
    importModel(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      //文件校验，不通过则停止执行
      const isContinue = this.onFormat(file);
      if (!isContinue) return;
      let param = new FormData();
      // 将得到的文件流添加到FormData对象
      param.append("file", file.raw, file.name);
      // param.append("fileType", "brand");
      this.$http({
        url: "/upload",
        data: param,
        type: "upload",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          if (res.code === 0) {
            this.fileList = [
              {
                url:
                  "http://gov.eagle.datastory.com.cn/api/v0.5/file/images/" +
                  res.data.fileName,
                name: file.name,
              },
            ];
            this.$message({
              message: "上传成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "上传失败,请重新上传",
              type: "error",
            });
            this.fileList = [];
            this.$refs.brandUpload.clearFiles();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            message: "上传失败,请重新上传",
            type: "error",
          });
          this.fileList = [];
          this.$refs.brandUpload.clearFiles();
        });
    },
    submit() {
      this.formData.keyword = this.keywordList.filter((key) => key).join("|");
      const data = { ...this.formData };

      if (this.fileList.length === 0) {
        delete data.brandLogo;
      } else {
        data.brandLogo = this.fileList[0].url;
      }

      this.$refs.brandForm
        .validate()
        .then(() => {
          data.enterpriseId = this.enterpriseList.find(
            (t) => t.enterpriseName === this.formData.enterpriseName
          ).enterpriseId;

          const url = this.edit
            ? "/brandKey/updateBrand"
            : "/brandKey/insertBrand";
          this.$http({
            url,
            method: "post",
            data,
          }).then((res) => {
            if (res.code === 200) {
              const message = this.edit ? "编辑成功" : "添加成功";
              this.$message({
                message,
                type: "success",
              });
              this.beforeClose();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log("表单校验失败");
        });
    },
    // 关闭前的回调
    beforeClose() {
      this.formData = {
        enterpriseName: "",
        enterpriseId: "",
        brandName: "",
        brandLogo: "",
        isCompete: 0,
        keyword: "",
        status: 0,
      };
      this.keywordList = [];
      this.$emit("update");
      this.$emit("close-modal");
      this.$refs.brandUpload.clearFiles();
      this.$refs.brandForm.resetFields();
    },
    removeKeyword(keyword, index) {
      this.keywordList.splice(index, 1);
    },
    addKeyword() {
      this.keywordList.push("");
    },
    removeFile() {
      this.fileList = [];
    },
  },
};
</script>

<style lang="scss">
.dialog_box {
  border-radius: 10px;
}
.form_footer {
  padding-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/brandWord/keywordModal.vue